import { render, staticRenderFns } from "./ArchivoPdf.vue?vue&type=template&id=7a4a1dd2&scoped=true"
import script from "./ArchivoPdf.vue?vue&type=script&lang=js"
export * from "./ArchivoPdf.vue?vue&type=script&lang=js"
import style0 from "./ArchivoPdf.vue?vue&type=style&index=0&id=7a4a1dd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4a1dd2",
  null
  
)

export default component.exports